import React from "react";
import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import Shell from "../components/Shell";
import { endpoints } from "../lib/api";
import { UBot } from "../components/UBot";
import { PrimaryButton } from "../components/bits";

export default function SignInPage() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [website, setWebsite] = React.useState("");
  const [sent, setSent] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { setErr("That email doesn't look quite right"); return; }
    setErr(""); setBusy(true);
    try { await endpoints.requestLink({ email, website }); setSent(true); }
    catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(d === "rate_limited" ? "Too many tries. Wait a few minutes, then try again."
        : d === "email_unavailable" ? "Sign-in emails are paused right now. Please try again later."
        : "Hmm, that didn't send. Try again.");
    }
    finally { setBusy(false); }
  };

  return (
    <Shell>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col items-center justify-center px-4 py-12 text-center">
        <UBot size={100} />
        {sent ? (
          <div data-testid="signin-sent">
            <h1 className="mt-4 font-display text-[28px] font-extrabold text-white">Check your inbox 📬</h1>
            <p className="mt-2 text-on-dark-muted">We sent a sign-in link to {email}. It works for 15 minutes.</p>
            <button onClick={() => setSent(false)} className="mt-5 rounded-pill border border-white/15 px-5 py-2.5 font-semibold text-white">Resend link</button>
          </div>
        ) : (
          <>
            <h1 className="mt-4 font-display text-[28px] font-extrabold text-white">Sign in with a magic link ✨</h1>
            <p className="mt-2 text-on-dark-muted">No password needed. We'll email you a link that signs you in.</p>
            <form onSubmit={submit} className="mt-6 w-full space-y-3">
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-400" />
                <input data-testid="signin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
                  className="w-full rounded-pill border border-white/15 bg-white/5 py-3 pl-9 pr-3 text-[15px] text-white outline-none placeholder:text-ink-400 focus:border-gold-500" />
              </div>
              {err && <p className="text-[13px] text-coral-500">{err}</p>}
              <input tabIndex={-1} className="hidden" value={website} onChange={(e) => setWebsite(e.target.value)} aria-hidden />
              <PrimaryButton type="submit" disabled={busy} className="w-full" data-testid="signin-submit">{busy ? "Sending…" : "Send my link"}</PrimaryButton>
            </form>
            <p className="mt-4 text-[13px] text-ink-400">Signing in is optional. It just keeps your saved list and support history across devices.</p>
          </>
        )}
      </div>
    </Shell>
  );
}
